import React from "react";

/**
 * Renders a city icon as an SVG component.
 *
 * @param {Object} cls - the class name for the SVG component
 * @return {JSX.Element} the city icon SVG component
 */
export const CityIcon = ({ cls }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g clipPath="url(#clip0_464_1487)">
        <path
          d="M6.365 4.26966C5.339 3.24345 3.66 3.24345 2.634 4.26966L0.685 6.21908C0.246 6.65818 0 7.2533 0 7.87344V19.4989C0 22.2605 2.239 24.5 5 24.5H9V7.87444C9 7.2533 8.753 6.65818 8.314 6.21908L6.365 4.26966ZM5 19.4999H4C3.448 19.4999 3 19.0518 3 18.4997C3 17.9476 3.448 17.4995 4 17.4995H5C5.552 17.4995 6 17.9476 6 18.4997C6 19.0518 5.552 19.4999 5 19.4999ZM5 15.4991H4C3.448 15.4991 3 15.051 3 14.4989C3 13.9467 3.448 13.4986 4 13.4986H5C5.552 13.4986 6 13.9467 6 14.4989C6 15.051 5.552 15.4991 5 15.4991ZM5 11.4982H4C3.448 11.4982 3 11.0501 3 10.498C3 9.94588 3.448 9.49779 4 9.49779H5C5.552 9.49779 6 9.94588 6 10.498C6 11.0501 5.552 11.4982 5 11.4982Z"
          fill="currentColor"
        />
        <path
          d="M19 0.5H16C13.239 0.5 11 2.739 11 5.5V24.5H19C21.761 24.5 24 22.261 24 19.5V5.5C24 2.739 21.761 0.5 19 0.5ZM16 19.5H15C14.448 19.5 14 19.052 14 18.5C14 17.948 14.448 17.5 15 17.5H16C16.552 17.5 17 17.948 17 18.5C17 19.052 16.552 19.5 16 19.5ZM16 15.5H15C14.448 15.5 14 15.052 14 14.5C14 13.948 14.448 13.5 15 13.5H16C16.552 13.5 17 13.948 17 14.5C17 15.052 16.552 15.5 16 15.5ZM16 11.5H15C14.448 11.5 14 11.052 14 10.5C14 9.948 14.448 9.5 15 9.5H16C16.552 9.5 17 9.948 17 10.5C17 11.052 16.552 11.5 16 11.5ZM16 7.5H15C14.448 7.5 14 7.052 14 6.5C14 5.948 14.448 5.5 15 5.5H16C16.552 5.5 17 5.948 17 6.5C17 7.052 16.552 7.5 16 7.5ZM20 19.5H19C18.448 19.5 18 19.052 18 18.5C18 17.948 18.448 17.5 19 17.5H20C20.552 17.5 21 17.948 21 18.5C21 19.052 20.552 19.5 20 19.5ZM20 15.5H19C18.448 15.5 18 15.052 18 14.5C18 13.948 18.448 13.5 19 13.5H20C20.552 13.5 21 13.948 21 14.5C21 15.052 20.552 15.5 20 15.5ZM20 11.5H19C18.448 11.5 18 11.052 18 10.5C18 9.948 18.448 9.5 19 9.5H20C20.552 9.5 21 9.948 21 10.5C21 11.052 20.552 11.5 20 11.5ZM20 7.5H19C18.448 7.5 18 7.052 18 6.5C18 5.948 18.448 5.5 19 5.5H20C20.552 5.5 21 5.948 21 6.5C21 7.052 20.552 7.5 20 7.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_464_1487">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
